<template>
  <div class="service">
    <utopa-title :title="showData.TITLE.title"
                 :des="showData.TITLE.des">
    </utopa-title>
    <div class="service-tabs">
      <ul class="service-tabs-ul">
        <li v-for="tab in showData.TABS"
            :class="{'active': activeId === tab.id}"
            :key="tab.id"
            @click="tabClick(tab)">
          {{tab.name}}
          <span v-show="activeId === tab.id"></span>
        </li>
      </ul>
      <div class="service-info">
        <card3 v-for="info in showData.TABINFOS"
               :key="info.id"
               :banner="info.banner"
               :title="info.title"
               :des="info.des"
               :infos="info.infos"
               :infosTitle="info.infosTitle"
               v-show="activeId === info.id">
          <div class="service-info-slot"
               v-if="activeId === 1">
            <img @click.prevent
                 :src="showData.IMG1"
                 width="100%">
            <div class="service-info-slot-card">
              <div class="service-info-slot-card_left">
                <img @click.prevent
                     :src="showData.IMG2"
                     width="100%">
              </div>
              <div class="service-info-slot-card_content">
                <h5>{{showData.TITLE2.title}}</h5>
                <p v-html="showData.TITLE2.des"></p>
              </div>
            </div>
          </div>
          <div class="service-info-slot"
               v-if="activeId === 4">
            <p class="service-info-slot-p"
               v-html="showData.P"></p>
          </div>
        </card3>
      </div>
    </div>
  </div>
</template>

<script>
import language from 'mixins/language' // 预留 多语言混入实例
import card3 from 'components/card3.vue'
import utopaTitle from 'components/title.vue'
export default {
  name: '',
  props: [''],
  mixins: [language],
  data () {
    return {
      activeId: 1,
      CN: {
        TITLE: {
          title: '运营服务',
          des: '优托邦UTOPA营运中心设立了资产管理服务、客户资源服务、品牌营销服务、创新科技服务四大运营管理部门，保证品牌和项目的持续经营，旨在为合作伙伴、商户、消费群体等多方提供系统性、多元化的价值服务。'
        },
        TITLE2: {
          title: '所获殊荣',
          des: '美国绿色建筑委员会LEED O+M铂金级认证<br>RICS China Awards 2018 年度可持续发展成就优秀奖、“设施管理团队冠军”大奖、“商业地产项目优秀奖”'
        },
        P: '依托丰富商业地产运营管理经验，简化项目运营管理，为优托邦企业联盟会员提供全新商业地产操作系统（UTOPA OS）。打造商业运营全新多维度生态体系、用整体运营面对线上线下各类竞争。',
        TABS: [
          { id: 1, name: '资产管理' },
          { id: 2, name: '客户资源' },
          { id: 3, name: '品牌营销' },
          { id: 4, name: '创新科技' }
        ],
        TABINFOS: [
          {
            id: 1,
            banner: require('images/service/1.png'),
            title: '资产安全服务、资产保值及增值服务',
            des: '提供管理创新、专业发展、新技术运用等专业运营服务的商业物业资产管理和服务平台，最大化发挥和提高物业效益，实现资产的保值和增值。',
            infos: [
              { txt: '人工智能和节能降耗技术实现资产持续增值' },
              { txt: '人脸识别系统强化商场安保体系' },
              { txt: '三维四波架构体系全面维护物业安全' }
            ],
            infosTitle: '高科技，高安全系统'
          },
          {
            id: 2,
            banner: require('images/service/2.png'),
            title: '资源整合及客户服务',
            des: '通过与国际及国内品牌客户资源，建立及维护良好的合作关系，与客户共同进行市场拓展、商品销售、营销传播等多方面合作，使客户持续盈利。',
            infos: [
              { txt: '提供线上和实体资源平台型合作；' },
              { txt: '提供线上线下开店销售、广告传播、营销推广、业内及跨界交流等多方位服务，实现资源互通互享；' },
              { txt: '用文化、创意赋能商业活动，吸引更多客户资源集；' }
            ]
          },
          {
            id: 3,
            banner: require('images/service/3.png'),
            title: '品牌创建和市场营销服务',
            des: '从满足人的多元化需求出发，以文化为创新驱动力，连接线上线下，多方位为消费群体提供优质的物质产品和精神产品。',
            infos: [
              { txt: '对企业品牌的多元文化进行发掘和创造，满足用户的不同产品和文化体验需求；' },
              { txt: '融合线上线下社交空间，营造年度、季度及月度主题动，为消费者创造精神体验与情感交流的机会，丰富人们生活方式；' }
            ]
          },
          {
            id: 4,
            banner: require('images/service/4.png'),
            title: '科技应用及创新开发服务',
            des: '运用前瞻性的创新思维和科技手段，将现实与虚拟的世界连结，打造多维度的社交空间，为商业运营管理及会员服务提供强有力的支持服务技术。',
            infos: [
              { txt: '打造以用户需求为核心的线上线下与一站式服务平台；以娱乐、运动、 艺术、美食等多场景提供最完美的商圈智慧购物与生活方式；' },
              { txt: '全面聚合商家各种生活服务，写字楼门禁、停车系统、智能wifi系统为用户提供统一的生活服务入口，提供了优托邦商圈内吃、住、行、游、购、娱一站式全新体验；' },
              { txt: '联结现实与虚拟，利用VR、AR、XR等智能技术增强用户体验维度，在虚拟世界满足精神需求，获得恒常喜悦；' },
              { txt: '改变传统运营管理方式，用云服务、大数据、物联网、AI机器学习等前沿技术，联结投资者、业主、品牌、商户、用户和资源提供者，打 造线上线下融合的全新运营式。' }
            ]
          }
        ],
        IMG1: require('images/service/11.png'),
        IMG2: require('images/service/12.png')
      },
      ZH: {
        TITLE: {
          title: '運營服務',
          des: '優托邦UTOPA營運中心設立了資產管理服務、客戶資源服務、品牌營銷服務、創新科技服務四大運營管理部門，保證品牌和項目的持續經營，旨在為合作夥伴、商戶、消費群體等多方提供系統性、多元化的價值服務。'
        },
        TITLE2: {
          title: '所獲殊榮',
          des: '美國綠色建築委員會LEED O+M鉑金級認證<br>RICS China Awards 2018 年度可持續發展成就優秀獎、“設施管理團隊冠軍”大獎、“商業地產項目優秀獎”'
        },
        P: '依託豐富商業地產運營管理經驗，簡化專案運營管理，為優托邦企業聯盟會員提供全新商業地產作業系統（UTOPA OS）。打造商業運營全新多維度生態體系、用整體運營面對線上線下各類競爭。',
        TABS: [
          { id: 1, name: '資產管理' },
          { id: 2, name: '客戶資源' },
          { id: 3, name: '品牌營銷' },
          { id: 4, name: '創新科技' }
        ],
        TABINFOS: [
          {
            id: 1,
            banner: require('images/service/1.png'),
            title: '資產安全服務、資產保值及增值服務',
            des: '提供管理創新、專業發展、新技術運用等專業運營服務的商業物業資產管理和服務平臺，最大化發揮和提高物業效益，實現資產的保值和增值。',
            infos: [
              { txt: '人工智慧和節能降耗技術實現資產持續增值' },
              { txt: '人臉識別系統強化商場安保體系' },
              { txt: '三維四波架構體系全面維護物業安全' }
            ],
            infosTitle: '高科技·高安全系統'
          },
          {
            id: 2,
            banner: require('images/service/2.png'),
            title: '資源整合及客戶服務',
            des: '通過與國際及國內品牌客戶資源，建立及維護良好的合作關係，與客戶共同進行市場拓展、商品銷售、營銷傳播等多方面合作，使客戶持續盈利。',
            infos: [
              { txt: '提供線上和實體資源平臺型合作；' },
              { txt: '提供線上線下開店銷售、廣告傳播、營銷推廣、業內及跨界交流等多方位服務，實現資源互通互享；' },
              { txt: '用文化、創意賦能商業活動，吸引更多客戶資源聚集；' }
            ]
          },
          {
            id: 3,
            banner: require('images/service/3.png'),
            title: '品牌創建和市場營銷服務',
            des: '從滿足人的多元化需求出發，以文化為創新驅動力，連接線上線下，多方位為消費群體提供優質的物質產品和精神產品。',
            infos: [
              { txt: '對企業品牌的多元文化進行發掘和創造，滿足用戶的不同產品和文化體驗需求；' },
              { txt: '融合線上線下社交空間，營造年度、季度及月度主題活動，為消費者創造精神體驗與情感交流的機會，豐富人們生活方式；' }
            ]
          },
          {
            id: 4,
            banner: require('images/service/4.png'),
            title: '科技應用及創新開發服務',
            des: '運用前瞻性的創新思維和科技手段， 將現實與虛擬的世界連結，打造多維度的社交空間，為商業運營管理及會員服務提供強有力的支援服務技術。',
            infos: [
              { txt: '打造以用戶需求為核心的線上線下與一站式服務平臺；以娛樂、運動、 藝術、美食等多場景提供最完美的商圈智慧購物與生活方式；' },
              { txt: '全面聚合商家各種生活服務，寫字樓門禁、停車系統、智慧wifi系統為使用者提供統一的生活服務入口，提供了優托邦商圈內吃、住、行、遊、 購、娛一站式全新體驗；' },
              { txt: '聯結現實與虛擬，利用VR、AR、XR等智慧技術增強用戶體驗維度， 在虛擬世界滿足精神需求，獲得恒常喜悅' },
              { txt: '   改變傳統運營管理方式，用雲服務、大資料、物聯網、AI機器學習等 前沿技術，聯結投資者、業主、品牌、商戶、用戶和資源提供者，打造線上線下融合的全新運營模式。' }
            ]
          }
        ],
        IMG1: require('images/service/11_1.png'),
        IMG2: require('images/service/12.png')
      }
    }
  },
  components: { card3, utopaTitle },
  watch: {},
  computed: {},
  created () { },
  mounted () { },
  methods: {
    tabClick (tab) {
      this.activeId = tab.id
    }
  }
}

</script>
<style lang='scss' scoped>
@import "px2rem";
.active {
  background: #ff5c43;
  border-color: #ff5c43 !important;
  color: #ffffff !important;
}
.service {
  padding-top: px2rem(54);
  /deep/ .title-p {
    padding: px2rem(12) px2rem(14) 0;
  }
  &-tabs {
    padding: px2rem(20) 0;
    &-ul {
      text-align: center;
      li {
        display: inline-block;
        box-shadow: 0 px2rem(1) px2rem(2) 0 rgba(5, 51, 75, 0.1);
        border-radius: px2rem(2);
        border: px2rem(0.5) solid #e0e0e0;
        width: px2rem(81);
        line-height: px2rem(30);
        font-size: px2rem(14);
        color: #3c3c3c;
        margin: 0 px2rem(4);
        position: relative;
        font-weight: bold;
        span {
          display: block;
          position: absolute;
          width: px2rem(8);
          height: px2rem(8);
          background: #ff5c43;
          transform: rotate(45deg);
          bottom: px2rem(-4);
          left: 50%;
          margin-left: px2rem(-4);
        }
      }
    }
  }
  &-info {
    padding: px2rem(24) px2rem(14) 0;
    &-slot {
      margin-top: px2rem(16);
      &-card {
        position: relative;
        margin-top: px2rem(20);
        height: px2rem(173);
        &_left {
          position: absolute;
          width: px2rem(110);
          height: px2rem(173);
          left: 0;
          top: 0;
        }
        &_content {
          margin-left: px2rem(124);
          h5 {
            font-size: px2rem(14);
            color: #333333;
            font-weight: bold;
            padding: px2rem(15) 0;
          }
          p {
            font-size: px2rem(13);
            color: #666666;
            line-height: px2rem(20);
          }
        }
      }
      &-p {
        font-size: px2rem(13);
        color: #666666;
        line-height: px2rem(20);
      }
    }
  }
}
</style>
